import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const BulletList = ({ items }) => (
  <List>
    {items.map((item, index) => (
      <ListItem key={index} sx={{ padding: '2px 8px' }}>
        <ListItemIcon sx={{ minWidth: '32px', alignSelf: 'flex-start', marginTop: '10px' }}> {/* Adjust alignment here */}
          <FiberManualRecordIcon style={{ fontSize: '12px' }} />
        </ListItemIcon>
        <ListItemText primary={item} />
      </ListItem>
    ))}
  </List>
);

export default BulletList;
